import { z } from "zod"

export const ProductCategoryCreateSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, { message: "Product Category name must be at least 2 character." })
    .max(25, { message: "Product Category name must not exceed 25 characters." })
    .regex(/^[a-zA-Z0-9&.,'\-()[\]! ]*$/, {
      message:
        "Product Category name can only contain letters, numbers, spaces, and these special characters: . , ' - ( ) [ ] & !",
    }),
})

export const ProductCategoryEditSchema = ProductCategoryCreateSchema.extend({
  categoryId: z.string().trim().min(1, { message: "Category ID is required for edit mode." }),
})

// Infer the keys of the schema
export type ProductCategoryCreateSchemaKeys = keyof z.infer<typeof ProductCategoryCreateSchema>
export type ProductCategoryEditSchemaKeys = keyof z.infer<typeof ProductCategoryEditSchema>
